var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1867 12.6823C14.07 12.6707 13.93 12.6707 13.8017 12.6823C11.025 12.589 8.82001 10.314 8.82001 7.51398C8.82001 4.65565 11.13 2.33398 14 2.33398C16.8583 2.33398 19.18 4.65565 19.18 7.51398C19.1683 10.314 16.9633 12.589 14.1867 12.6823Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35334 16.986C5.53001 18.876 5.53001 21.956 8.35334 23.8343C11.5617 25.981 16.8233 25.981 20.0317 23.8343C22.855 21.9443 22.855 18.8643 20.0317 16.986C16.835 14.851 11.5733 14.851 8.35334 16.986Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6db109b67b41970951b879f4b3af7f36.svg";
export { ForwardRef as ReactComponent };